// Common nationality list (adjectival form) for dropdown selects, alphabetically ordered.
export const NATIONALITIES = [
    'Afghan', 'Algerian', 'American', 'Argentine', 'Australian', 'Bahraini',
    'Bangladeshi', 'Belgian', 'Brazilian', 'British', 'Bulgarian', 'Cameroonian',
    'Canadian', 'Chilean', 'Chinese', 'Colombian', 'Croatian', 'Danish',
    'Dutch', 'Egyptian', 'Emirati', 'Ethiopian', 'Filipino', 'Finnish',
    'French', 'German', 'Ghanaian', 'Greek', 'Indian', 'Indonesian', 'Iranian',
    'Iraqi', 'Irish', 'Italian', 'Japanese', 'Jordanian', 'Kenyan', 'Korean',
    'Kuwaiti', 'Lebanese', 'Malaysian', 'Mexican', 'Moroccan', 'Nepalese',
    'New Zealander', 'Nigerian', 'Norwegian', 'Omani', 'Pakistani',
    'Palestinian', 'Peruvian', 'Polish', 'Portuguese', 'Qatari', 'Romanian',
    'Russian', 'Saudi', 'Serbian', 'South African', 'Spanish', 'Sri Lankan',
    'Sudanese', 'Swedish', 'Swiss', 'Syrian', 'Tanzanian', 'Thai', 'Tunisian',
    'Turkish', 'Ugandan', 'Ukrainian', 'Venezuelan', 'Vietnamese', 'Yemeni',
    'Other'
];
